export default __webpack_public_path__ + "static/media/snapMan.7f839900.png";